module.exports = __webpack_public_path__ + "media/images/vip-table-9e483af819080727e7ae1a1cdb9f7571.svg";